import { shallowEqual, useSelector } from 'react-redux';
import { getReferralMembers } from '../../selectors';
import { IReferralCampaignMember } from '../../interfaces';
import { IStore } from 'store/interface';

export const useReferralMembers = (id?: string) => ({
  members: useSelector<IStore, IReferralCampaignMember[]>(getReferralMembers(id), shallowEqual),
});
